export default __webpack_public_path__ + "static/customer_relations-8e022620ca4403b4ec1015bef504ddc3.jpeg";